// extracted by mini-css-extract-plugin
export var exitIcon = "photo-module--exitIcon--1MZ2H";
export var fullscreenDesc = "photo-module--fullscreenDesc--1Bslm";
export var fullscreenPhoto = "photo-module--fullscreenPhoto--PxTnD";
export var heading = "photo-module--heading--X7G8W";
export var main = "photo-module--main--DV18F";
export var photos = "photo-module--photos--PjSIf";